import { D, type ByChatHistory } from '@wave/shared';

/**
 * Топ-N чатов по вкладу в изменение позиции между моментами `prevTs` и
 * `currTs`. Кошельки (source='tron') исключены: они активы, их вклад
 * показывает отдельная строка тултипа («кошельки …» в TrendChart).
 *
 * Сопоставление — ПО `ts`, а не по позиции в массиве `points` конкретного
 * чата. Ряд отдельного чата может быть короче общего тренда: в
 * `loadByChatHistory` (`apps/api/.../chat-balances/history.ts`) бакет чата
 * пропускается целиком, если в нём ни у одной валюты нет курса USDT
 * (`if (r.net === null) continue`), а у чата, появившегося позже начала
 * диапазона, точек изначально меньше. Позиционная индексация (`points[i]`)
 * в этих случаях указывала бы на чужое время — тултип показал бы дельту не
 * того момента. Если у чата нет точки на `prevTs` или `currTs` — его вклад
 * не оценивается (чат пропускается), а не подставляется нулём: ноль был бы
 * придуманным значением, а не отсутствием данных.
 */
export function topContributors(
  byChat: ByChatHistory,
  prevTs: string,
  currTs: string,
  limit = 3,
): Array<{ title: string; deltaUsdt: number }> {
  return byChat.chats
    .filter((c) => c.source !== 'tron')
    .map((c) => {
      const curr = c.points.find((p) => p.ts === currTs)?.netUsdt;
      const prev = c.points.find((p) => p.ts === prevTs)?.netUsdt;
      if (curr === undefined || prev === undefined) return null;
      return { title: c.title, deltaUsdt: D(curr).minus(D(prev)).toNumber() };
    })
    .filter((c): c is { title: string; deltaUsdt: number } => c !== null && c.deltaUsdt !== 0)
    .sort((a, b) => Math.abs(b.deltaUsdt) - Math.abs(a.deltaUsdt))
    .slice(0, limit);
}
